<template>
    <div>
        <div class="panel-header">
            <span class="panel-bar"></span>
            <span class="panel-title">基本资料</span>
        </div>
        <div class="form">
            <div class="row">
                <div class="label">
                    <span class="req">*</span>
                    昵称
                </div>
                <div class="value">
                    <span class="text">{{ profile.nickname }}</span>
                    <img class="meta-icon" @click="$emit('edit', 'nickname')" src="@/assets/编辑 1@2x.png" alt="" />
                </div>
            </div>

            <div class="row">
                <div class="label" style="padding-left: 10px;">邮箱</div>
                <div class="value">
                    <span class="text">{{ profile.email }}</span>
                    <button class="link" type="button" @click="openEditEmail">修改</button>
                </div>
            </div>

            <div class="row">
                <div class="label">手机号</div>
                <div class="value">
                    <span class="text">{{ profile.phone }}</span>
                    <button class="link" type="button" @click="openVerifyPhone">修改</button>
                </div>
            </div>
        </div>
        <!-- 邮箱：修改新邮箱 -->
        <el-dialog v-model="dialogs.editEmailVisible" width="698px" :show-close="false" :close-on-click-modal="true"
            :close-on-press-escape="false" class="email-dialog">
            <div class="dialog-tips">
                <span class="warn-dot">修改新邮箱</span>
                <span class="dialog-tip">
                    <img class="meta-icon" src="@/assets/提示说明.png" alt="" />
                    为确保账号酱*是您本人操作，请输入邮箱验证码验证身份
                </span>
            </div>
            <div class="dialog-form">
                <div class="f-row">
                    <div class="f-label">邮箱</div>
                    <div class="f-control">
                        <el-input placeholder="请输入新邮箱" />
                    </div>
                </div>

                <div class="f-row">
                    <div class="f-label">验证码</div>
                    <div class="f-control">
                        <el-input placeholder="请输入验证码">
                            <template #suffix>
                                <button class="send-code-in" type="button">发送验证码</button>
                            </template>
                        </el-input>
                    </div>
                </div>
                <div class="f-row">
                    <div class="f-label"></div>
                    <div class="f-control">
                        <div class="dialog-actions">
                            <el-button class="primary-btn" type="success" @click="goVerifyEmail">立即验证</el-button>
                        </div>

                        <div class="dialog-footnote">
                            <div>1. 接收验证码的邮箱为您填写的新邮箱</div>
                            <div>2. 发送验证码后，您可以在邮箱收件箱中获取</div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- 邮箱：验证新邮箱 -->
        <el-dialog v-model="dialogs.verifyEmailVisible" width="698px" :show-close="false" :close-on-click-modal="true"
            :close-on-press-escape="false" class="email-dialog">
            <div class="dialog-tips">
                <span class="warn-dot" style="font-weight: 400;">验证身份</span>
                <span class="dialog-tip">
                    <img class="meta-icon" src="@/assets/提示说明.png" alt="" />
                    <span>为确保账号酱*是您本人操作，请输入邮箱验证码验证身份</span>
                </span>
            </div>
            <div class="dialog-form">
                <div class="f-row">
                    <div class="f-label">邮箱</div>
                    <div class="f-control">
                        <div class="readonly-text">12****78@126.com</div>
                    </div>
                </div>
                <div class="f-row">
                    <div class="f-label">验证码</div>
                    <div class="f-control">
                        <el-input placeholder="请输入验证码">
                            <template #suffix>
                                <button class="send-code-in" type="button">发送验证码</button>
                            </template>
                        </el-input>
                    </div>
                </div>
                <div class="f-row">
                    <div class="f-label"></div>
                    <div class="f-control">
                        <div class="dialog-actions">
                            <el-button class="primary-btn" type="success"
                                @click="dialogs.verifyEmailVisible = false">立即验证</el-button>
                        </div>

                        <div class="dialog-footnote">
                            <div>1. 接收验证码的邮箱为您填写的新邮箱</div>
                            <div>2. 发送验证码后，您可以在邮箱收件箱中获取</div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- 手机号：验证身份（先出现） -->
        <el-dialog v-model="dialogs.verifyPhoneVisible" width="698px" :show-close="false" :close-on-click-modal="true"
            :close-on-press-escape="false" class="email-dialog">
            <div class="dialog-tips">
                <span class="warn-dot" style="font-weight: 400;">修改新手机号</span>
                <span class="dialog-tip">
                    <img class="meta-icon" src="@/assets/提示说明.png" alt="" />
                    为确保账号酱*是您本人操作，请输入手机号验证身份
                </span>
            </div>

            <div class="dialog-form">
                <div class="f-row">
                    <div class="f-label" style="font-weight: 400;">手机号</div>
                    <div class="f-control">
                        <div class="readonly-text">{{ profile.phone }}</div>
                    </div>
                </div>

                <div class="f-row">
                    <div class="f-label" style="font-weight: 400;">验证码</div>
                    <div class="f-control">
                        <el-input placeholder="请输入验证码">
                            <template #suffix>
                                <button class="send-code-in" type="button">发送验证码</button>
                            </template>
                        </el-input>
                    </div>
                </div>

                <!-- ✅ 同上：按钮+备注跟 input 一样宽 -->
                <div class="f-row">
                    <div class="f-label"></div>
                    <div class="f-control">
                        <div class="dialog-actions">
                            <el-button class="primary-btn" type="success" @click="goEditPhone">立即验证</el-button>
                        </div>

                        <div class="dialog-footnote">
                            <div>1. 接收验证码的手机号为您账户绑定的安全手机号</div>
                            <div>2. 发送验证码后，您可以在手机短信中获取</div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>

        <!-- 手机号：修改新手机号（后出现） -->
        <el-dialog v-model="dialogs.editPhoneVisible" width="698px" :show-close="false" :close-on-click-modal="true"
            :close-on-press-escape="false" class="email-dialog">
            <div class="dialog-tips">
                <span class="warn-dot" style="font-weight: 400;">验证身份</span>
                <span class="dialog-tip">
                    <img class="meta-icon" src="@/assets/提示说明.png" alt="" />
                    为确保账号酱*是您本人操作，请输入手机号验证身份
                </span>
            </div>

            <div class="dialog-form">
                <div class="f-row">
                    <div class="f-label" style="font-weight: 400;">手机号</div>
                    <div class="f-control">
                        <el-input placeholder="请输入新手机号" />
                    </div>
                </div>

                <div class="f-row">
                    <div class="f-label" style="font-weight: 400;">验证码</div>
                    <div class="f-control">
                        <el-input placeholder="请输入验证码">
                            <template #suffix>
                                <button class="send-code-in" type="button">发送验证码</button>
                            </template>
                        </el-input>
                    </div>
                </div>

                <!-- ✅ 同上：按钮+备注跟 input 一样宽 -->
                <div class="f-row">
                    <div class="f-label"></div>
                    <div class="f-control">
                        <div class="dialog-actions">
                            <el-button class="primary-btn" type="success"
                                @click="dialogs.editPhoneVisible = false">立即验证</el-button>
                        </div>
                        <div class="dialog-footnote">
                            <div>1. 接接收验证码的手机号为您账号中绑定的安全手机号</div>
                            <div>2. 发送验证码后，您可以在手机短信中获取</div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script setup>
import { reactive } from 'vue'

defineProps({
    profile: {
        type: Object,
        default: () => ({
            nickname: '',
            email: '',
            phone: '',
        }),
    },
})

defineEmits(['edit', 'update-profile'])

const dialogs = reactive({
    editEmailVisible: false,
    verifyEmailVisible: false,
    verifyPhoneVisible: false,
    editPhoneVisible: false,
})

function openEditEmail() {
    dialogs.editEmailVisible = true
}
function goVerifyEmail() {
    dialogs.editEmailVisible = false
    dialogs.verifyEmailVisible = true
}

function openVerifyPhone() {
    dialogs.verifyPhoneVisible = true
}
function goEditPhone() {
    dialogs.verifyPhoneVisible = false
    dialogs.editPhoneVisible = true
}
</script>

<style scoped lang="scss">
:deep .el-input {
    height: 48px;
}

:deep .el-input .el-input__wrapper {
    border-radius: 8px;
}

.panel-header {
    display: flex;
    align-items: center;
    gap: 7px;
    margin-bottom: 34px;
}

.panel-bar {
    width: 3px;
    height: 16px;
    border-radius: 2px;
    background: #4caf50;
}

.panel-title {
    font-weight: 500;
    font-size: 18px;
    color: #495060;
}

.form {
    padding-left: 22px;
}

.row {
    display: flex;
    align-items: center;
    min-height: 44px;
    margin: 10px 0;
}

.label {
    width: 72px;
    font-weight: 500;
    font-size: 14px;
    color: #303133;
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

.meta-icon {
    width: 16px;
    height: 16px;
}

.req {
    color: #e74c3c;
    font-weight: 700;
    transform: translateY(-1px);
}

.value {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
}

.text {
    font-size: 16px;
    color: #2b2f33;
}

.link {
    border: none;
    background: transparent;
    padding: 0;
    cursor: pointer;
    font-weight: 400;
    font-size: 16px;
    color: #4caf50;
}

.link:hover {
    text-decoration: underline;
}

/* -------- 弹窗样式（复用） -------- */
.email-dialog :deep(.el-dialog) {
    border-radius: 8px;
}

.dialog-header {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 6px;
}

.dialog-title {
    font-weight: 600;
    font-size: 14px;
    color: #303133;
}

.dialog-tips {
    display: flex;
    align-items: center;
    // justify-content: center;
    margin-bottom: 36px;
    padding-left: 95px;
}

.dialog-tip {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 3px 8px;
    background: #fff2ea;
    border-radius: 4px;
    font-size: 12px;
    color: #e6a23c;
}

.warn-dot {
    font-weight: 600;
    font-size: 14px;
    color: #333333;
    margin-right: 12px;
}

.dialog-tip-plain {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: #e6a23c;
    font-size: 12px;
    margin-bottom: 18px;
}

.warn-dot-plain {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 1px solid rgba(230, 162, 60, 0.35);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
}

.dialog-form {
    padding: 0 64px;
    margin: 0 auto;
}

.f-row {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
}

.f-label {
    width: 70px;
    color: #303133;
    font-size: 14px;
    font-weight: 500;
    text-align: right;
    padding-right: 12px;
    box-sizing: border-box;
}

.f-control {
    flex: 1;
}

/* 发送验证码在 input 内 */
.send-code-in {
    border: none;
    background: transparent;
    padding: 0 4px 0 10px;
    margin-left: 6px;
    cursor: pointer;
    font-weight: 600;
    font-size: 16px;
    color: #4caf50;
    white-space: nowrap;
    line-height: 1;
}

:deep(.el-input__suffix) {
    display: inline-flex;
    align-items: center;
}

.dialog-actions {
    margin-top: 25px;
    /* ✅ 关键：让 actions 容器占满 f-control 宽度 */
    width: 100%;
}

.primary-btn {
    /* ✅ 关键：按钮占满 f-control（也就是 input）宽度 */
    width: 100%;
    height: 48px;
    background: #4caf50;
    border-radius: 4px;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
}

.readonly-text {
    height: 32px;
    line-height: 32px;
    color: #606266;
}

.dialog-footnote {
    /* ✅ 关键：备注占满 f-control（也就是 input）宽度 */
    width: 100%;
    margin-top: 12px;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    line-height: 1.6;
}
</style>